module.exports = __webpack_public_path__ + "static/people@2x-c02ba82841f77a8180ccb81ff2c6890e.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/why-marvel/people@2x.png
// module id = 2723
// module chunks = 168707334958949